export class UpdateBorrowerSharedEvent {
    constructor(
      public sharedWith: number[]
    ) {}
}
